import React, {useEffect, useState} from 'react';
import {Alert, Button, FormField, Input, Spinner,} from "@tag/tag-components-react-v4";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import AppRolesService from "../../General/services/AppRolesService";
import RestoreEnvService from "../../APP/services/RestoreEnvService";
import styles from "../../APP/CustomerList/CustomerList.module.scss";
import { ProjectAccents } from "../../General/config/projectAccents";
import EnvironmentService from "../services/EnvironmentService";
import EnvironmentSelector from "../components/EnvironmentSelector";
import { AppEnvironment } from "../types/AppEnvironment";

const APPLinkDB = () => {
    const [appGrpName, setAppGrpName] = useState<string>('');
    const [dbName, setDbName] = useState<string>('');
    const [customerName, setCustomerName] = useState<string>('');
    const [alert, setAlert] = useState<{type: any, message: string}>();
    const [environments, setEnvironments] = useState<AppEnvironment[]>([]);
    const [selectedEnvironment, setSelectedEnvironment] = useState<string>('');

    const { accounts, inProgress } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        EnvironmentService.getEnvironments()
            .then(environmentOptions => {
                setEnvironments(environmentOptions);
                const defaultEnvironment = environmentOptions.find(environment => environment.isDefault)
                    ?? environmentOptions[0];
                setSelectedEnvironment(defaultEnvironment?.name ?? '');
            })
            .catch(() => setEnvironments([]));
    }, []);

    while (!inProgress) {
        if (!AppRolesService.isUserAdmin(accounts, isAuthenticated)) {
            throw new Error()
        }
    }
    
    const [loading, setLoading] = useState<boolean>();
    
    const isButtonDisabled = () => {
        return !appGrpName || !dbName || !customerName
            || (environments.length > 1 && !selectedEnvironment);
    }
    
    const resetValues = () => {
        setAppGrpName('');
        setDbName('');
        setCustomerName('');
    }
    
    const onButtonClick = () => {
        if (isButtonDisabled()) {
            return;
        }
        
        setLoading(true);
        RestoreEnvService.linkDatabase(appGrpName, dbName, customerName, selectedEnvironment || undefined)
            .then((e) => {
                setLoading(false);
                setAlert({type: 'success', message: 'Successfully Linked DB'})
                resetValues()
            })
            .catch((e) => {
                setLoading(false);
                setAlert({type: 'error', message: e.message})
            })
    }

    let header = <h1>APP Link Database</h1>;
    let subHeader = <h5>This utility will create an entry in the corporate site for a customers database that exists in the AppGrp DB but not in corp site</h5>
    let content = null;
    if (loading) {
        content = <Spinner />;
    }
    else {
        content = (
            <div style={{width: '40%', margin: 'auto'}}>
                <EnvironmentSelector
                    environments={environments}
                    selected={selectedEnvironment}
                    onChange={setSelectedEnvironment}
                />
                <FormField
                    label="AppGroup/Environment Name"
                    labelProps={{style: {margin: 'auto'}}}
                    editor={<Input value={appGrpName} style={{ width: '100%' }} />}
                    hint={'e.g. AppGrp4 (Case Sensitive)'}
                    onChange={(e) => setAppGrpName((e.target as HTMLInputElement).value)}
                    required
                />
                <FormField
                    label="Full Database Name"
                    labelProps={{style: {margin: 'auto'}}}
                    editor={<Input value={dbName} style={{ width: '100%' }} />}
                    hint={'e.g. PeoplePlanner-XherdanCare (Case Sensitive)'}
                    onChange={(e) => setDbName((e.target as HTMLInputElement).value)}
                    required
                />
                <FormField
                    label="Customers Name"
                    labelProps={{style: {margin: 'auto'}}}
                    editor={<Input value={customerName} style={{ width: '100%' }} />}
                    hint={'e.g. Xherdan Care (Case Sensitive)'}
                    onChange={(e) => setCustomerName((e.target as HTMLInputElement).value)}
                    required
                />
                <br />
                <Button text={'Submit'} accent={ProjectAccents.PeoplePlanner} onClick={() => onButtonClick()} disabled={isButtonDisabled()} />
            </div>
        );
    }

    return (
        <>
            {header}
            {subHeader}
            {content}
            {alert ?
                <Alert
                    className={styles.CustomerListAlert}
                    closeTransition="fade"
                    type={alert.type}
                    showDuration={1200}
                    onClosed={() => setAlert(undefined)}
                >
                    {alert.message}
                </Alert> : undefined
            }
        </>
    );
}

export default APPLinkDB;
